// GHXST Voice Engine — Web Speech API
// Uses browser's built-in TTS, no API key needed
// Best voices: Microsoft Guy (Edge), Google UK (Chrome)

let currentUtterance = null;
let isSpeaking = false;

export function speak(text, onStart, onEnd, opts = {}) {
  if (!window.speechSynthesis) return;

  // Cancel anything currently speaking
  stop();

  const cleaned = text.replace(/[*_~`#]/g, '').trim();
  if (!cleaned) { onEnd?.(); return; }
  const utterance = new SpeechSynthesisUtterance(cleaned);

  // GHXST is a female mentor by default; pass { gender: 'male' } to override.
  const gender = opts.gender || 'female';
  const voices = window.speechSynthesis.getVoices();

  // Best available natural voices per gender, in priority order
  const preferredByGender = {
    female: [
      'Microsoft Aria Online (Natural) - English (United States)',
      'Microsoft Jenny Online (Natural) - English (United States)',
      'Microsoft Sonia Online (Natural) - English (United Kingdom)',
      'Google UK English Female',
      'Microsoft Zira Desktop - English (United States)',
      'Samantha',
    ],
    male: [
      'Microsoft Guy Online (Natural) - English (United States)',
      'Microsoft Ryan Online (Natural) - English (United Kingdom)',
      'Google UK English Male',
      'Microsoft David Desktop - English (United States)',
      'Alex',
    ],
  };
  const preferred = preferredByGender[gender] || preferredByGender.female;

  let chosen = null;
  for (const name of preferred) {
    chosen = voices.find(v => v.name === name);
    if (chosen) break;
  }
  // Fallback: any English voice matching the gender hint, then any English voice
  if (!chosen) chosen = voices.find(v => v.lang.startsWith('en') && v.name.toLowerCase().includes(gender));
  if (!chosen && gender === 'female') chosen = voices.find(v => v.lang.startsWith('en') && /aria|jenny|sonia|zira|samantha|susan|fiona|female/i.test(v.name));
  if (!chosen) chosen = voices.find(v => v.lang.startsWith('en'));
  if (chosen) utterance.voice = chosen;

  // Female mentor: slightly higher pitch than the old male default
  utterance.rate = 0.95;
  utterance.pitch = gender === 'female' ? 1.05 : 0.85;
  utterance.volume = 1;

  utterance.onstart = () => { isSpeaking = true; onStart?.(); };
  utterance.onend = () => { isSpeaking = false; currentUtterance = null; onEnd?.(); };
  utterance.onerror = () => { isSpeaking = false; currentUtterance = null; onEnd?.(); };

  currentUtterance = utterance;

  // Chrome bug fix — voices need a tiny delay
  setTimeout(() => window.speechSynthesis.speak(utterance), 50);
}

export function stop() {
  window.speechSynthesis?.cancel();
  isSpeaking = false;
  currentUtterance = null;
}

export function getIsSpeaking() { return isSpeaking; }

export function loadVoices() {
  return new Promise(resolve => {
    const voices = window.speechSynthesis.getVoices();
    if (voices.length > 0) return resolve(voices);
    window.speechSynthesis.onvoiceschanged = () => resolve(window.speechSynthesis.getVoices());
  });
}
